import * as React from "react";
import "./App.css";
import WebApp from "./Elements/WebApp";
import Login from "./Elements/Pages/user/Login";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import NewAccount from "./Elements/Pages/user/NewAccount";
import ForgotPassword from "./Elements/Pages/user/ForgotPassword";
import LogoutButton from "./Elements/Pages/user/LogoutButton";
import Verify from "./Elements/Pages/user/Verify";
import { observer } from "mobx-react";
import store from "./Store";

export interface IMainAppProps {}

export interface IMainAppState {
  customerNames: any[];
  error: string;
}

class MainApp extends React.Component<IMainAppProps, IMainAppState> {
  constructor(props: IMainAppProps) {
    super(props);

    this.state = {
      customerNames: [],
      error: "",
    };
  }

  public render() {
    return (
      <div>
        <Router>
          <Routes>
            {/* Login page */}
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logoLogoutButton" element={<LogoutButton />} />
            <Route path="/Verify" element={<Verify />} />

            {/* User account management */}
            <Route path="/NewAccount" element={<NewAccount />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* Admin panel routes */}
            <Route 
              path="/admin/*" 
              element={
                (() => {
                  const isAuth = store.isAuthenticated || localStorage.getItem('admin_token');
                  console.log('MainApp: Route check - isAuthenticated:', store.isAuthenticated, 'hasToken:', !!localStorage.getItem('admin_token'));
                  return isAuth ? <WebApp /> : <Navigate to="/login" replace />;
                })()
              } 
            />
          </Routes>
        </Router>
      </div>
    );
  }
}

export default observer(MainApp);
